import { usePlanAccess } from '../hooks/usePlanAccess';
import UpgradeGate from './UpgradeGate';

const PlanGate = ({ module, children }) => {
  const { plan, hasAccess, loading } = usePlanAccess();

  if (loading) return null;
  if (!hasAccess(module)) {
    const requiredPlan = module === 'ai-assistant' ? 'enterprise' : 'pro';
    return <UpgradeGate requiredPlan={requiredPlan} currentPlan={plan} moduleName={module} />;
  }
  return children;
};

export default PlanGate;
